export const getDefaultAuthConfig = () => ({
  loginURL: '',
  username: '',
  password: '',
});

export const createAuthSettingsDraft = authConfig => {
  const source = authConfig || getDefaultAuthConfig();
  return {
    loginURL: source.loginURL || '',
    username: source.username || '',
    password: source.password || '',
  };
};

export const buildAuthSettingsPayload = draft => ({
  loginURL: (draft?.loginURL || '').trim(),
  username: (draft?.username || '').trim(),
  password: (draft?.password || '').trim(),
});

export const hasAuthConfigValues = authConfig => {
  const { loginURL, username, password } = buildAuthSettingsPayload(authConfig);
  return Boolean(loginURL || username || password);
};
